import React from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Divider, Tag as TagBase, Tooltip as TooltipBase } from "antd";
import { useMedia } from "react-use";
import * as actions from "../../../../actions";

// import { useWhyDidYouUpdate } from "../../../hooks/useWhyDidYouUpdate";

import { FiltersState } from "../../../../reducers/filters";
import { State, Dictionary } from "../../../../interfaces";
import DynamicIcon from "../../../DynamicIcon";

// ponytail: antd4's CheckableTag/TooltipProps predate React 18's stricter children typing; cast until antd5 migration
const Tag: any = TagBase;
const Tooltip: any = TooltipBase;
const { CheckableTag } = Tag;

interface Props {
  labels?: Dictionary<string>;
}

let Typologies: React.FC<Props> = props => {
  const { labels } = props;

  const filters: FiltersState = useSelector(
    (state: State) => state.filters,
    shallowEqual
  );
  const values = filters.typologies?.entities;
  let tmpTypologies = filters.typologies?.selectedTypologies;
  if(!tmpTypologies){
    tmpTypologies = [];
  } else if(Array.isArray(tmpTypologies)){
    tmpTypologies = tmpTypologies.map((typology: any) => {
      if(typeof typology === "object" && typology?.id){
        return typology.id;
      }
      return typology;
    });
  }
  const selectedTypologies = tmpTypologies;

  const hasHover = useMedia("(hover: hover)");

  const dispatch = useDispatch();

  const toggle = (id: string) => {
    dispatch(actions.toggleTypologyOnSelectedList(id));
  };

  const _onReset = () => {
    dispatch(actions.setTypology([]));
  };

  const reset = selectedTypologies.length ? (
    <CloseCircleOutlined onClick={_onReset} />
  ) : null;

  return (
    <>
      <Divider className="filters-label" orientation="left">
        {labels?.typologies} {reset}
      </Divider>
      <div className="typology-wrapper search-panel-element">
        {values.all.map((_id: string) => {
          const { id, name, icon } = values.byId[_id];
          return hasHover ? (
            <Tooltip
              key={id}
              title={name}
              placement="topLeft"
              arrowPointAtCenter
              mouseLeaveDelay={0}
              getPopupContainer={(triggerNode: HTMLElement) =>
                triggerNode.parentNode as HTMLElement
              }
            >
              <CheckableTag
                className="typology-tag"
                checked={selectedTypologies.indexOf(id) > -1 || selectedTypologies[0] == id}
                onChange={(checked: boolean) => toggle(id)}
              >
                <DynamicIcon type={icon} />
              </CheckableTag>
            </Tooltip>
          ) : (
            <CheckableTag
              key={id}
              className="typology-tag"
              checked={selectedTypologies.indexOf(id) > -1 || selectedTypologies[0] == id}
              onChange={(checked: boolean) => toggle(id)}
            >
              <DynamicIcon type={icon} />
            </CheckableTag>
          );
        })}
      </div>
    </>
  );
};

export default Typologies;
